import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import LabelFont from '../../Theme/Fonts/Label'
import { TestID } from '../../utils/PropTypesDefinitions'
import BetButton from './BetButton'
import Logo from './Logo'

export enum OddsProvider {
    BWIN = 'bwin',
    HPYBET = 'hpybet',
    INTERWETTEN = 'interwetten',
    TIPICO = 'tipico',
    UNIBET = 'unibet',
    NEOBET = 'neobet',
}

type Odd = {
    label?: string
    value: string
}

export type BetProps = {
    /**
     * list of possible odds
     * */
    odds: Odd[]
    /**
     * which bet provider's logo to show
     * */
    oddsProvider: OddsProvider
    /**
     * callback when an odd gets pressed
     * @TJS-type function
     * */
    onPressOdd: (index: number) => void
    /**
     * callback when the provider gets pressed
     * @TJS-type function
     * */
    onPressProvider?: () => void
    display?: 'flex' | 'none' | ('none' | 'flex')[]
    width?: number
    marginRight?: number
    marginLeft?: number
} & TestID

const Bet: FC<BetProps> = ({
    display,
    width,
    marginLeft,
    marginRight,
    odds,
    oddsProvider,
    onPressOdd,
    onPressProvider,
    testID,
}) => {
    return (
        <Grid
            noExpand
            testID={testID}
            height={30}
            width={width}
            horizontal
            centerVertical
            backgroundColor="tahitian"
            display={display}
            marginLeft={marginLeft}
            marginRight={marginRight}
        >
            <Grid noExpand center marginX={4} minWidth={24}>
                <LabelFont color="keshi-3" numberOfLines={1}>
                    -w-
                </LabelFont>
            </Grid>
            {odds.map((odd, index) => {
                return (
                    <Grid
                        key={`${odd.value}-${index}`}
                        centerVertical
                        minWidth={0}
                        paddingLeft={index === 0 ? 0 : 2}
                        paddingRight={index === odds.length - 1 ? 0 : 2}
                    >
                        <Touchable onPress={(): void => onPressOdd(index)}>
                            <BetButton label={odd.label} value={odd.value} />
                        </Touchable>
                    </Grid>
                )
            })}
            <Touchable onPress={onPressProvider}>
                <Logo provider={oddsProvider} />
            </Touchable>
        </Grid>
    )
}

export default Bet
